import * as core from '@spyglassmc/core';
import { arrayToMessage, localeQuote, localize } from '@spyglassmc/locales';
import { compound } from './compound.js';
export const path = (src, ctx) => {
    const ans = { type: 'nbt:path', children: [], range: core.Range.create(src) };
    let expectedParts = ['filter', 'key'];
    let currentPart = nextPart(src);
    let cursor;
    while (cursor !== src.cursor) {
        if (!expectedParts.includes(currentPart)) {
            ctx.err.report(localize('expected-got', arrayToMessage(expectedParts.map(localizePart), false, 'or'), localizePart(currentPart)), src);
        }
        if (currentPart === 'end') {
            break;
        }
        cursor = src.cursor;
        expectedParts = PartParsers[currentPart](ans.children, src, ctx);
        currentPart = nextPart(src);
    }
    ans.range.end = src.cursor;
    return ans;
};
const filter = (children, src, ctx) => {
    const node = compound(src, ctx);
    children.push({
        type: 'nbt:path/filter',
        range: node.range,
        children: [node],
    });
    return src.trySkip('.') ? ['key'] : ['end'];
};
const index = (children, src, ctx) => {
    const node = {
        type: 'nbt:path/index',
        children: undefined,
        range: core.Range.create(src),
    };
    if (!src.trySkip('[')) {
        throw new Error(`NBT path index parser called at illegal position: “${src.peek()}” at ${src.cursor}`);
    }
    src.skipSpace();
    const c = src.peek();
    if (c === '{') {
        node.children = [compound(src, ctx)];
    }
    else if (c !== ']') {
        node.children = [core.integer({ pattern: /^-?\d+$/ })(src, ctx)];
    }
    src.skipSpace();
    if (!src.trySkip(']')) {
        ctx.err.report(localize('expected-got', localeQuote(']'), localeQuote(src.peek())), src);
    }
    node.range.end = src.cursor;
    children.push(node);
    return src.trySkip('.') ? ['index', 'key'] : ['end', 'index'];
};
const key = (children, src, ctx) => {
    const node = core.setType('nbt:string', core.string({
        colorTokenType: 'property',
        escapable: {},
        // Single quotes supported since 1.20 Pre-release 2 (roughly pack format 15)
        // https://bugs.mojang.com/browse/MC-175504
        quotes: ['"', "'"],
        unquotable: { blockList: new Set(['\n', '\r', '\t', ' ', '"', '[', ']', '.', '{', '}']) },
    }))(src, ctx);
    children.push({
        type: 'nbt:path/key',
        range: node.range,
        children: [node],
    });
    return src.trySkip('.') ? ['index', 'key'] : ['end', 'filter', 'index'];
};
function nextPart(src) {
    switch (src.peek()) {
        case '':
        case ' ':
        case '\n':
        case '\r':
            return 'end';
        case '{':
            return 'filter';
        case '[':
            return 'index';
        default:
            return 'key';
    }
}
function localizePart(part) {
    return localize(`nbt.node.path.${part}`);
}
const PartParsers = { filter, index, key };
//# sourceMappingURL=path.js.map